import React from "react";
import "./Gift.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Button, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faFileLines } from "@fortawesome/free-solid-svg-icons";

function Gift() {
  return (
    <>
      <section className="Gift">
        <Common_white_header headingText={"Gift"} />
        <div className="container">
          <div className="gift_banner_img_holder">
            <img
              src="/assets/images/gift/banner_img.png"
              alt="banner"
              className="banenr_img"
            />
          </div>

          <div className="card_holder">
            <div className="text_holder">
              <p>Hi </p>
              <p>We have a gift for you</p>

              <h6>Please enter the gift code below</h6>

              <div className="field_holder">
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Please enter gift code"
                  />
                </Form.Group>
              </div>

              <Button
                className="btn_register_bg mb-3"
                // onClick={() => setModalShow(true)}
              >
                Receive
              </Button>
            </div>
          </div>

          <div className="Gift_History_holder">
            <div className=" History_header">
              <div className="header-left">
                <span className="header_icon">
                  <FontAwesomeIcon icon={faBook} />
                </span>
                <h4> History</h4>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Gift;
